// @flow
/* eslint sort-keys: "error"*/

/**
 * Keep this in alphabetical order to avoid merge conflicts.
 * Name conventions:
 * - Use HA_SERP prefix for all tests
 * - Use FF suffix for feature flags
 * TODO: runtime configuration of these tests
 */
const TESTS = {
    HA_FAB_FILTERS_2LESSGREYOUT: 'ha_fab_filters_2lessGreyout',
    HA_GDPR_BANNER: 'ha_gdpr_banner',
    HA_GX_POST_BRAND_TRANSITION: 'HA_GX_POST_BRAND_TRANSITION',
    HA_GX_PRE_BRAND_TRANSITION: 'HA_GX_PRE_BRAND_TRANSITION',
    HA_IDA_LOGIN_TO_SAVE_TRIPBOARD: 'HA_IDA_LOGIN_TO_SAVE_TRIPBOARD',
    HA_IDA_SERP_GOOGLEONETAP: 'HA_IDA_SERP_GOOGLEONETAP',
    HA_IDA_SERP_HEADER_LOGIN_TEST: 'HA_IDA_SERP_HEADER_LOGIN_TEST',
    HA_IDA_V3_LOGIN_TEST: 'HA_IDA_V3_LOGIN_TEST',
    HA_MULTIUNIT_PHOTO_CAROUSEL_TEST: 'HA_MULTIUNIT_PHOTO_CAROUSEL_TEST',
    HA_NATIVE_ADOPTION_BANNER_SEARCH_UI: 'HA_NATIVE_ADOPTION_BANNER_SEARCH_UI',
    HA_PTA_HEADER_LOGIN_COPY: 'HA_PTA_HEADER_LOGIN_COPY',
    HA_PTA_LANDING_CLADSONSERP: 'HA_PTA_LANDING_CLAdsOnSeRP',
    HA_PTA_LANDING_SERP_TO_SLP_PHASE_1: 'HA_PTA_LANDING_SERPtoSLPPhase1',
    HA_PTA_SEARCHBOX_ADD_AGE_OF_CHILDREN: 'HA_PTA_SEARCHBOX_addAgeOfChildren',
    HA_PTA_SEARCHBOX_HINTTEXTCHOOSINGDATES:
        'HA_PTA_SEARCHBOX_hintTextChoosingDates',
    HA_PULSE_SAVE_CONFIRMATION_SERP_HIT: 'ha_pulse_save_confirmation_serp_hit',
    HA_SERP_ABACUS_PAYLOAD_LIVELAB_CSS: 'HA_SERP_ABACUS_PAYLOAD_LIVELAB_CSS',
    HA_SERP_NUMBER_OF_HITS: 'HA_SERP_NUMBER_OF_HITS',
    HA_SERP_RESULTS_QUERY_REJECTION: 'HA_SERP_RESULTS_QUERY_REJECTION',
    HA_SERP_SEARCHFORM_COMPONENT_V2: 'HA_SERP_SEARCHFORM_v2',
    HA_SERP_SEARCHFORM_ROLLOUT: 'HA_SERP_SEARCHFORM',
    HA_TOTAL_PRICE_FILTER: 'ha_total_price_filter',
    HA_TRAVELER_HEADER_TRAY_MOBILE_APP: 'HA_TRAVELER_HEADER_TRAY_MOBILE_APP',
    HA_TYPEAHEAD_LID_SEARCH: 'HA_TYPEAHEAD_LID_SEARCH',
    HA_TYPEAHEAD_TWO_LINE_DISPLAY: 'ha_typeahead_two_line_display_v2',
    MESO_VRBO_DISPLAY_ADS: 'MESO_Vrbo_display_ads',
    VRBO_LANDING_COLOUR_CONTRAST_ON_SEARCHFORM:
        'VRBO_LANDING_colourContrastOnSearchForm',
    VRBO_OPAS_SECONDARY_PRICE_EU: 'vrbo_opas_secondary_price_eu',
    VRBO_RECO_LARGE_SEARCH_DESTINO: 'Vrbo_reco_large_search_destino',
    VRBO_RECO_LOW_SEARCH_DESTINO: 'Vrbo_reco_Low_search_destino',
    VRBO_SERP_PDP_COVID_BANNER: 'vrbo_serp_pdp_covid_banner',
    VRBO_WEB_FLEX_DATE_A_INSIGHT: 'vrbo_web_flex_date_a_insight',
    VRBO_WEB_GLOBAL_MESSAGING_ALERT: 'vrbo_web_global_messaging_alert',
    VRBO_WEB_GLOBAL_MESSAGING_BANNER: 'vrbo_web_global_messaging_banner',
    VRBO_WEB_SERP_FEWER_INITIAL_RESULTS: 'vrbo_web_serp_fewer_initial_results'
};
/* The below array evaluated with abacus client utils when this module is dispatched to redux to create the abacus state */
const EVALUATE = Object.values(TESTS);
const EVALUATE_AND_LOG = [];

module.exports = {
    EVALUATE,
    EVALUATE_AND_LOG,
    ...TESTS
};
